import FreeLabel from "../../assets/image/free-label_2.png";
import Lawdark from "../../assets/image/lawdark-logo.webp";
import { useNavigate } from "react-router-dom";
import paths from "../../utils/paths";
import { getCloudinaryAvatar } from "../../utils/commonUtils";

export default function TemplateCard({
  templateId,
  templateName,
  templateDescription,
  advocateName,
  templateamount,
  profileImgSrc,
  templateCity,
  templateState,
  isEditable = false,
  isUserCreated,
  ownerTemplateId,
  className,
}) {
  const navigate = useNavigate();
  return (
    <div className={className}>
      <div className="employ-agreement-card">
        <div className="card card-shadow">
          <img
            src={FreeLabel}
            alt="free label"
            className="free-template-label"
          />
          <div className="card-head">
            <img src={Lawdark} alt="Header" style={{ width: "150px" }} />
            <h3 className="text-break">{templateName}</h3>
            <p>{templateDescription}</p>
            <div className="attorney-name">
              <p>Name</p>
              <h4>{advocateName}</h4>
            </div>
          </div>
          <div className="card-body d-flex flex-column">
            <h5 className="card-title card-agreement txt-black">
              {templateName}
            </h5>
            <div>
              <div className="employe-img">
                <img
                  src={
                    getCloudinaryAvatar(profileImgSrc, 25) ||
                    "https://res.cloudinary.com/dapljmrfe/image/upload/w_25,h_25,c_fill,f_auto,q_auto/v1738408387/mhlkd4uc8strhaarznzk.jpg"
                  }
                  alt="User Profile"
                  style={{ width: "25px" }}
                />
                <p>{advocateName}</p>
              </div>
              <div className="price-lbt">
                <div className="price-content">
                  <p>Price</p>
                  <h4>{templateamount} LBT</h4>
                </div>
                <div className="price-content">
                  <p className="text-align-end">Location</p>
                  <h4>
                    {templateCity && templateState ? (
                      <>{templateCity + ", " + templateState}</>
                    ) : (
                      <>
                        {templateCity}
                        {templateState}
                      </>
                    )}
                  </h4>
                </div>
              </div>
            </div>
            <div className="buy-shop-content d-flex justify-content-end mt-auto">
              <button
                onClick={() =>
                  navigate(`${paths.LegalDocuments}/${ownerTemplateId}`)
                }
                // className="log-btn buy-btn gradientButton"
                className="gradientButton rounded py-1 px-3"
              >
                View Details
              </button>
              {isEditable && (
                <button
                  onClick={() =>
                    navigate(`${paths.EditTemplate}/${templateId}`, {
                      state: { isUserCreated },
                    })
                  }
                  className="gradientButton rounded py-1 px-3"
                >
                  Edit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
